export default __webpack_public_path__ + "static/media/disabled_arrow.ba6e4c64.svg";